import { render, staticRenderFns } from "./TelaTabelaBase.vue?vue&type=template&id=8da96a3a&scoped=true"
import script from "./TelaTabelaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./TelaTabelaBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da96a3a",
  null
  
)

export default component.exports